// extracted by mini-css-extract-plugin
export default {"main":"Tpm9-6tNeSqFmc8CYGFNfA==","correct":"-e3nazGB7GFVg5QJtCzBrw==","warning":"_4+8tTDB3IqgHLK35OrGHDg==","incorrect":"i8GSZxRflVUp71sCc5sOQg=="};